/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Qualify_Title7Inputs */

const en_svc_ai_voice_agents_qualify_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead qualification`)
};

const ar_svc_ai_voice_agents_qualify_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأهيل العملاء المحتملين`)
};

const bn_svc_ai_voice_agents_qualify_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লিড যোগ্যতা যাচাই`)
};

const de_svc_ai_voice_agents_qualify_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead-Qualifizierung`)
};

const es_svc_ai_voice_agents_qualify_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación de leads`)
};

const fr_svc_ai_voice_agents_qualify_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualification de leads`)
};

const pt_svc_ai_voice_agents_qualify_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualificação de leads`)
};

const zh_svc_ai_voice_agents_qualify_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`线索筛选`)
};

const tr_svc_ai_voice_agents_qualify_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri adayı niteleme`)
};

const ru_svc_ai_voice_agents_qualify_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Квалификация лидов`)
};

const pl_svc_ai_voice_agents_qualify_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Qualify_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwalifikacja leadów`)
};

/**
* | output |
* | --- |
* | "Lead qualification" |
*
* @param {Svc_Ai_Voice_Agents_Qualify_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_qualify_title7 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Qualify_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Qualify_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_qualify_title7(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_qualify_title7(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_qualify_title7(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_qualify_title7(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_qualify_title7(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_qualify_title7(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_qualify_title7(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_qualify_title7(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_qualify_title7(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_qualify_title7(inputs)
	return en_svc_ai_voice_agents_qualify_title7(inputs)
});
export { svc_ai_voice_agents_qualify_title7 as "svc_ai-voice-agents_QUALIFY_title" }